import request from '@/api/request'


var getIndexList = (params) => {
  return request({
    url: '/mock/index.json',
    method: 'get',
    params
  })
}

var getCode = (params) => {
  return request({
    url: '/api/orgz/get-vcode',
    method: 'get',
    params
  })
}

var hasCustomer = (params) => {
  return request({
    url: '/api/orgz/has_customer',
    method: 'get',
    params
  })
}

var saveSubmit = (data) => {
  return request({
    url: '/api/orgz/add/request_customerCs',
    method: 'post',
    data
  })
}

export default {
  getIndexList,
  hasCustomer,
  getCode,
  saveSubmit
}